export default "__VITE_ASSET__B8YoRg7Q__"